'use client';

import { c as _c } from "react/compiler-runtime";
import { styled } from '@classify/react-core-components/styles';
import Typography from '@classify/react-core-components/Typography';
import Box from '@classify/react-core-components/Box';
import { translate } from '@openclassrooms/translations';
import ApplyButton from '@openclassrooms/common-app/applications/components/ApplyButton';
import ContentWrapper from '@classify/react-core-components/ContentWrapper';
import Image from 'next/image';
import diplomaImageUrl from './images/diploma.svg';
const BannerSection = styled('section')(({
  theme: {
    breakpoints,
    spacing,
    palette
  }
}) => ({
  background: palette.layout.surface.alternativeBackground,
  paddingTop: spacing(4),
  paddingBottom: spacing(4),
  [breakpoints.up('sm')]: {
    paddingTop: spacing(5),
    paddingBottom: spacing(5)
  }
}));
const TextContent = styled(Box)({
  flexGrow: 1
});
const ImageContent = styled(Box)(({
  theme: {
    breakpoints
  }
}) => ({
  display: 'none',
  '& > img': {
    width: 200
  },
  [breakpoints.up('sm')]: {
    display: 'flex',
    minWidth: 280,
    alignItems: 'center',
    justifyContent: 'center',
    '& > img': {
      width: 'auto'
    }
  }
}));
const OffersDiplomaBanner = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      display: "flex",
      gap: 4,
      alignItems: "center"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Typography variant="h4" component="h2" sx={{
      mb: 1
    }}>{translate("free_user.offer_diploma.intro.title")}</Typography>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Typography variant="subheading" paragraph={true}>{translate("free_user.offer_diploma.orientation.title")}</Typography>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      marginTop: 1
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <TextContent>{t1}{t2}<Box sx={t3}><ApplyButton variant="primary">{translate("free_user.offer_diploma.button_orientation")}</ApplyButton></Box></TextContent>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <BannerSection><ContentWrapper><Box sx={t0}>{t4}<ImageContent><Image src={diplomaImageUrl} alt="" width={280} height={217} /></ImageContent></Box></ContentWrapper></BannerSection>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
export default OffersDiplomaBanner;